import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { FormatDurationPipe } from "../../../../../helpers/datehelper/duration";
import { AuthService } from "../../../../../services/authservice";
import { DialogAuthComponent } from "../../../../dialogs/dialog-auth/dialog-auth";
import { DialogMessageComponent } from "../../../../dialogs/dialog-message/dialog-message";

@Component({
  selector: "self-service-item",
  templateUrl: "self-service-item.html",
  styleUrl: "../../shortcut-menu.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule, FormatDurationPipe],
})
export class SelfServiceItem {
  private translate = inject(TranslateService);
  private dialog = inject(MatDialog);
  private auth = inject(AuthService);

  readonly dirty = input.required<boolean>();

  protected hasRole = computed(() =>
    this.auth.hasRole(["Infraverantwoordelijke", "surfcert-kernel", "Beveiligingsverantwoordelijke"]),
  );
  protected isAuthenticatedForSelfService = computed(() => this.auth.selfServiceStarted());
  protected selfServiceTokenValidFor = computed(() => this.auth.selfServiceTokenValidFor());
  protected selfServiceDisabled = computed(() => this.dirty());

  constructor() {
    if (this.auth.hasPendingStrongAction("")) {
      this.auth.clearPendingStrongAction("");
      this.showAuthDialog(true);
    }
  }

  private showAuthDialog(state: boolean) {
    this.dialog.open(DialogAuthComponent, { data: { state } });
  }

  protected startSelfService() {
    this.showAuthDialog(false);
  }

  protected showWrongRoleMessage() {
    this.dialog.open(DialogMessageComponent, {
      data: {
        title: this.translate.instant("Dialog.Selfservice.RoleError.Title"),
        message: this.translate.instant("Dialog.Selfservice.RoleError.Message", {
          role: this.auth.getRoleNames(),
        }),
      },
    });
  }
}
